/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  message, Modal, Form, Divider, Spin, Empty, Space, Image,
} from 'antd'

import { fetch } from '../../utils/fetch'

import UploadImage from './UploadImage'

const ImageModal = ({
  action, orderId, headerId, itemId, visible, onCancel, editing,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [masteImgType, setMasteImgType] = useState([])
  const [imageList, setImageList] = useState([])
  const [form] = Form.useForm()

  const getMasterImgType = () => {
    fetch({
      url: '/master/image-type',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        setMasteImgType(res.data.data)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  const getOrderImgList = () => {
    setIsLoading(true)
    form.resetFields()
    setImageList([])
    const apiUrl = (action !== undefined) && (action !== null) && (action === 'Header')
      ? `/order/${orderId}/image/header/${headerId}`
      : `/order/${orderId}/image/item/${itemId}`
    fetch({
      url: apiUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        setImageList(res.data.data)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (visible) {
      getMasterImgType()
      getOrderImgList()
    }
  }, [visible])

  const filterMasterType = (type) => imageList.filter((item) => type === item.imageTypeId)

  return (
    <Modal
      centered
      width={1000}
      confirmLoading={isLoading}
      title="Upload Image"
      visible={visible}
      cancelText="Cancel"
      onCancel={onCancel}
      footer={null}
      maskClosable={false}
    >
      <Form
        form={form}
        name="manage-job-form"
        layout="horizontal"
        preserve={false}
      >
        <Spin spinning={isLoading} tip="Loading...">
          {masteImgType.map((imageType) => (
            <>
              <Form.Item>
                <div>{imageType.masterImageTypeDesc}</div>
                {editing ? (
                  <UploadImage
                    action={action}
                    itemId={itemId}
                    orderId={orderId}
                    headerId={headerId}
                    editData={
                      imageList.filter((item) => (item.imageTypeId === imageType.masterImageTypeId),
                      ).map((img, index) => ({ ...img, uid: index }))
                    }
                    typeId={imageType.masterImageTypeId}
                    onCancel={visible}
                  />
                ) : (
                  <Space>
                    {
                        filterMasterType(imageType.masterImageTypeId).length === 0
                          ? (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)
                          : filterMasterType(imageType.masterImageTypeId)
                            .map((item) => (<Image width={100} src={item.url} />))
                      }
                  </Space>
                )}
              </Form.Item>
              {imageType.masterImageTypeId !== 5 && <Divider style={{ marginTop: '.35rem', marginBottom: '.35rem' }} />}
            </>
          ))}
        </Spin>
      </Form>
    </Modal>
  )
}

export default ImageModal
